import { UI_URL } from "common/constants";

export const TRELLO_AUTHORIZE = (workspace) =>
  `https://trello.com/1/authorize?expiration=never&name=Windu&scope=read,write,account&response_type=token&key=${
    process.env.REACT_APP_TRELLO_CLIENT
  }&return_url=${UI_URL()}/workspace?integration=trello?state=${workspace}&prompt=consent`;
